import type { ReactNode } from 'react'

interface NumberInputProps {
  label: string
  value: number
  onChange: (value: number) => void
  prefix?: ReactNode
  suffix?: ReactNode
  min?: number
  max?: number
  step?: number
  hint?: string
  accent?: 'emerald' | 'teal' | 'cyan' | 'amber'
}

const accentRing: Record<string, string> = {
  emerald: 'focus:border-emerald-500 focus:ring-emerald-500/20',
  teal: 'focus:border-teal-500 focus:ring-teal-500/20',
  cyan: 'focus:border-cyan-500 focus:ring-cyan-500/20',
  amber: 'focus:border-amber-500 focus:ring-amber-500/20',
}

function NumberInput({ label, value, onChange, prefix, suffix, min, max, step = 1, hint, accent = 'emerald' }: NumberInputProps) {
  return (
    <label className="block">
      <span className="mb-1.5 flex items-center justify-between text-sm font-medium text-slate-300">
        <span>{label}</span>
        {hint ? <span className="text-xs font-normal text-slate-500">{hint}</span> : null}
      </span>
      <span className="relative flex items-center">
        {prefix ? <span className="pointer-events-none absolute left-3 font-mono text-sm text-slate-400">{prefix}</span> : null}
        <input
          type="number"
          inputMode="decimal"
          value={Number.isFinite(value) ? value : 0}
          min={min}
          max={max}
          step={step}
          onChange={(e) => onChange(e.target.value === '' ? 0 : Number(e.target.value))}
          className={`w-full rounded-lg border border-slate-700 bg-slate-800/60 py-2.5 font-mono text-base text-slate-50 outline-none transition-colors ${prefix ? 'pl-7' : 'pl-3'} ${suffix ? 'pr-10' : 'pr-3'} ${accentRing[accent]} focus:ring-2`}
        />
        {suffix ? <span className="pointer-events-none absolute right-3 font-mono text-sm text-slate-400">{suffix}</span> : null}
      </span>
    </label>
  )
}

export default NumberInput
